import { translationOrganizations_da } from "./translationOrganizations.da";
import { defineBilingualTranslations } from "./translationTypes";
import { translationOrganizations_en } from "./translationOrganizations.en";

export const translationOrganizations = defineBilingualTranslations({
  da: translationOrganizations_da,
  en: translationOrganizations_en,
});
